module.exports = __webpack_public_path__ + "img/purjekas.0299f125.jpg";